module.exports = __webpack_public_path__ + "static/i-know-what-youre-doing-a58eaa7a2196d85394f515bc34af2c2d.jpg";